import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { Grid, Link, Typography } from "@mui/material";
import fussFree from "@static/img/icons/fuss_free.png";
import plasticFree from "@static/img/icons/plastic_free.png";
import restrictionFree from "@static/img/icons/restriction_free.png";
import { useState } from "react";
import { useStyle } from "./css/moreAboutESimStyle";

export const MoreAboutEsim = () => {
    const { t } = useTranslation(["sim", "glossary"]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCloseModal = () => setIsModalOpen(false);
    const handleDisplayModal = () => setIsModalOpen(true);

    const { classes } = useStyle();

    return (
        <>
            <Link color="primary" component="button" underline="always" variant="small" onClick={handleDisplayModal}>
                {t("sim:moreAboutEsim")}
            </Link>
            <Modal
                close={handleCloseModal}
                confirm={handleCloseModal}
                confirmLabel={t("glossary:gotIt")}
                isModalOpen={isModalOpen}
                title={t("sim:aboutEsim")}
            >
                <Typography className={classes.aboutESimItem}>{t("sim:aboutEsimText")}</Typography>
                <Grid className={classes.aboutESimContent} container direction="row">
                    <Grid container direction="row" justifyContent="space-around">
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("sim:plasticFreeTitle")} src={plasticFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("sim:plasticFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("sim:plasticFreeText")}</Typography>
                        </Grid>
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("sim:fussFreeTitle")} src={fussFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("sim:fussFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("sim:fussFreeText")}</Typography>
                        </Grid>
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("sim:restrictionFreeTitle")} src={restrictionFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("sim:restrictionFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("sim:restrictionFreeText")}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
};
